import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import calendar from './components/calendar'
import Color from './components/color'
import slider from './components/slider'
import html2canvas from 'html2canvas'
import cssart from './components/cssart'
import proseCollapsible from './components/prose-collapsible.js';
import {app as proseCollapsibleApp, section as proseCollapsibleSection, } from './components/prose-collapsible-wip-sections.js';
import priceCalculator from './components/price-calculator.js';
import TurndownService from 'turndown';
import { tables as turndownPluginGfmTables } from 'turndown-plugin-gfm';

window.Alpine = Alpine
window.Color = Color
window.html2canvas = html2canvas
window.TurndownService = TurndownService
window.turndownPluginGfmTables = turndownPluginGfmTables
Alpine.data('calendar', calendar)
Alpine.data('cssart', cssart)
Alpine.data('proseCollapsible', proseCollapsible)
Alpine.data('proseCollapsibleSection', proseCollapsibleSection)
Alpine.data('proseCollapsibleApp', proseCollapsibleApp)
Alpine.data('priceCalculator', priceCalculator)
Alpine.plugin(intersect)
Alpine.plugin(collapse)
Alpine.start()